module.exports = __webpack_public_path__ + "img/bg_brang.9274fef5.jpg";